import 'bootstrap/dist/css/bootstrap.min.css';
import './css/Pages.css';
import './css/Pricing.css';
import './css/Fonts.css';
import { Button, Col, Container, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { pricingTiers } from '../content';

function Pricing() {
  return (
    <div className="page">
      <header className="page-header">
        <Container>
          <p className="page-eyebrow">Pricing</p>
          <h1 className="page-title">Priced by application and site — not by seat</h1>
          <p className="page-lead">
            Field crews safety should never be a line item you hesitate over, so every tier includes
            unlimited field users. Pick the scope that matches your operation.
          </p>
        </Container>
      </header>

      <Container className="page-section">
        <Row className="g-4 align-items-stretch justify-content-center">
          {pricingTiers.map((tier) => (
            <Col md={6} lg={4} key={tier.id}>
              <div className={`tier-card h-100 ${tier.featured ? 'tier-card-featured' : ''}`}>
                <p className={`tier-badge ${tier.featured ? '' : 'tier-badge-hidden'}`}>
                  {tier.featured ? 'Most common' : ' '}
                </p>
                <h2 className="tier-name">{tier.name}</h2>
                <p className="tier-summary">{tier.summary}</p>

                <div className="tier-price-block">
                  {tier.price ? (
                    <>
                      <span className="tier-price">{tier.price}</span>
                      <span className="tier-cadence">{tier.cadence}</span>
                    </>
                  ) : (
                    <span className="tier-price-tbd">Contact for pricing</span>
                  )}
                </div>

                <Button
                  variant=""
                  as={Link}
                  to="/contact"
                  className={tier.featured ? 'btn-primary-ir w-100' : 'btn-outline-ir w-100'}
                >
                  {tier.cta}
                </Button>

                <ul className="feature-list tier-features">
                  {tier.includes.map((item) => (
                    <li key={item}>{item}</li>
                  ))}
                </ul>
              </div>
            </Col>
          ))}
        </Row>

        <p className="pricing-legal">
          Subscriptions are governed by the{' '}
          <Link to="/legal/subscription-agreement">InfoRight SaaS Subscription Agreement</Link> and
          our <Link to="/legal/acceptable-use">Acceptable Use Policy</Link>. See our{' '}
          <Link to="/legal/privacy">Privacy Policy</Link> for how we handle data.
        </p>

        <Row className="mt-5">
          <Col lg={10} className="mx-auto">
            <div className="pricing-note">
              <h2 className="section-title">What every tier includes</h2>
              <Row className="g-3 mt-1">
                <Col md={6}>
                  <ul className="feature-list">
                    <li>Unlimited field users</li>
                    <li>Mobile data capture</li>
                    <li>Implementation support</li>
                  </ul>
                </Col>
                <Col md={6}>
                  <ul className="feature-list">
                    <li>Migration off existing spreadsheets</li>
                    <li>Auditable records and history</li>
                    <li>Ongoing product updates</li>
                  </ul>
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
      </Container>

      <section className="cta-band">
        <Container className="text-center">
          <h2 className="cta-title">Not sure which tier fits?</h2>
          <p className="cta-text">
            Tell us how many sites you run and what you are replacing. We will be straight with you.
          </p>
          <Button as={Link} to="/contact" className="btn-light-ir">
            Request a Quote
          </Button>
        </Container>
      </section>
    </div>
  );
}

export default Pricing;
